module.exports = __webpack_public_path__ + "static/img/inflate.801baf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/content/inflate.png
// module id = 6aC/
// module chunks = 1